var isObject = require('./_is-object');
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};


//////////////////
// WEBPACK FOOTER
// ./~/jszip/~/core-js/library/modules/_an-object.js
// module id = 1373
// module chunks = 1